import * as React from 'react';
import { useSelector } from 'react-redux';

import type { UserAvatarProps } from '@portal/store/src/user/selectors';
import { userAvatarSelector } from '@portal/store/src/user/selectors';
import { UserAvatar as NewUserAvatar } from '@portal/ui-lib';

import type { ApplicationState } from '@/store';

/**
 * @deprecated Please use <UserAvatar /> component from @portal/ui-lib
 */
export const UserAvatar = (props: UserAvatarProps) => {
  const selected = useSelector((state: ApplicationState) =>
    userAvatarSelector(state, props)
  );

  const { avatarUrl, className, size, name, withTooltip } = {
    ...props,
    ...selected,
  };

  return (
    <NewUserAvatar
      avatarUrl={avatarUrl}
      className={className}
      name={name}
      size={size}
      withTooltip={withTooltip}
    />
  );
};

export default UserAvatar;
